import { render } from "./EditProject.vue?vue&type=template&id=def5ffa6"
import script from "./EditProject.vue?vue&type=script&lang=js"
export * from "./EditProject.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__